<template>
    <div class="well-pgta-dropdown">
        <b-dropdown
            v-b-tooltip.hover
            variant="transparent"
            class="left-1 table-well-controls"
            block
            menu-class="w-100"
            :title="pgtaLabel"
            :text="pgtaLabel"
        >
            <template #button-content>
                <div class="well-pgta">
                    <span>{{ pgtaLabel }}</span>
                    <i class="fa fa-chevron-down select-button" />
                </div>
            </template>

            <b-dropdown-item
                v-for="value in pgtaValues"
                :key="value"
                class="well-pgta-item"
                href="#"
                @click="updateWellPgta(well, value)"
            >
                <div>{{ value ? $translate(value) : $translate('na') }}</div>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
import BackendProvider from '../../business/services/BackendProvider'
import UIUtils from '../../business/utils/UIUtils'
import { PGTA_VALUES } from '../../business/const'

export default {
    name: 'WellPgtaDropdown',
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            pgtaValues: PGTA_VALUES
        }
    },
    computed: {
        pgtaLabel() {
            return this.well.pgta ? this.$translate(this.well.pgta) : this.$translate('na')
        }
    },
    methods: {
        async updateWellPgta(well, pgta) {
            if (pgta === this.well.pgta) return

            UIUtils.showLoadingMask()
            await BackendProvider.updateWell(well._id, { pgta })
            this.well.pgta = pgta
            UIUtils.hideLoadingMask()
        }
    }
}
</script>

<style lang="scss">
.well-pgta-dropdown {
    width: 100%;

    .well-pgta {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 0 7px 10px;
    }

    .table-well-controls {
        .btn {
            font-size: 10.5pt;
            .select-button {
                border: 0.1rem solid transparent;
                border-radius: 3px;
                padding: 7px;

                &:hover {
                    border-color: $light-3;
                }
            }
        }

        .dropdown-menu {
            border: 0.1rem solid $dark;
            border-radius: 4px;
            background: $dark-4;
            padding: 0;
            top: 8px !important;
            font-size: 10.5pt;
            overflow: auto;
            min-width: 10rem;

            .well-pgta-item {
                height: 2.5rem;
                a {
                    background-color: transparent;
                    color: $light-3;
                }

                &:hover {
                    background-color: $dark-6;
                }
            }
        }

        .dropdown-item {
            padding: 12px 10px;
            cursor: pointer;
        }

        .dropdown-toggle {
            &::after {
                display: none;
            }
        }
    }
}
</style>
